import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ActionButton } from '../common/petCloud/ActionButton';
import { useResponsive } from '../../hooks/useResponsive';
import {
  DATE_FORMATS,
  formatDateByLanguage,
  formatShortDateByLanguage,
} from '../../services/language.utils';
import { IneligiblePetItem } from './IneligiblePetItem';

import styles from './ReviewIneligiblePets.module.css';

const ReviewIneligiblePets = ({
  coveragePeriodSelected = {},
  ineligiblePets = [],
  maxAgeByPeriod = '',
  onContinueClick = () => { },
  onGoBackClick = () => { },
}) => {
  const { t } = useTranslation('petDemos');
  const { isMobile } = useResponsive();

  const titleText = t('reviewIneligiblePets.title');

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {React.createElement(isMobile ? 'h3' : 'h2', null, titleText)}

        <h5>
          <Trans
            components={{ boldBlue: <span className={styles.periodDate} /> }}
            i18nKey="reviewIneligiblePets.subtitle"
            ns="petDemos"
            values={{
              endDate: formatShortDateByLanguage(
                coveragePeriodSelected.coverageEndDate,
              ),
              startDate: formatShortDateByLanguage(
                coveragePeriodSelected.coverageStartDate,
              ),
            }}
          />
        </h5>
      </div>

      <div className={styles.content}>
        {React.createElement(
          isMobile ? 'h4' : 'h3',
          null,
          <Trans
            components={{
              blue: <span className={styles.petCount} />,
            }}
            count={ineligiblePets.length}
            i18nKey="reviewIneligiblePets.ineligiblePetsCount"
            ns="petDemos"
            values={{ count: ineligiblePets.length }}
          />,
        )}

        <div className={styles.removalDate}>
          <h4>{t('completePetRemoval.removalDates')}</h4>
        </div>

        <p className={styles.maxAgeLabel}>
          {t('completePetRemoval.maxAgeLabel', { maxAge: maxAgeByPeriod })}
        </p>

        <div className={styles.ineligiblePetsList}>
          {ineligiblePets.map((pet) => {
            const formattedRemovalDate = pet.RemovalDate
              ? formatDateByLanguage({
                date: pet.RemovalDate,
                dateFormat: DATE_FORMATS.longWithMonthName,
              })
              : '';

            return (
              <IneligiblePetItem
                key={`${pet.Name}-${pet.dateOfBirth}`}
                dateOfBirth={pet.dateOfBirth}
                petName={pet.Name}
                removalDate={formattedRemovalDate}
                specie={pet.Specie}
              />
            );
          })}
        </div>
      </div>

      <div className={styles.buttonsContainer}>
        <ActionButton
          className={styles.actionButton}
          isSecondaryButton
          noMargin
          onClick={onGoBackClick}
          title={t('goBack')}
        />

        <ActionButton
          className={styles.actionButton}
          noMargin
          onClick={onContinueClick}
          title={t('reviewIneligiblePets.continueToAcknowledgements')}
        />
      </div>
    </div>
  );
};

export { ReviewIneligiblePets };
